const InvalidIdpSessionError = function(message, loginPage, samlRequest, relayState) {
  this.loginPage = loginPage
  this.message = message
  this.samlRequest = samlRequest
  this.relayState = relayState
}

InvalidIdpSessionError.prototype = Object.create(Error.prototype)
InvalidIdpSessionError.prototype.constructor = InvalidIdpSessionError

export default InvalidIdpSessionError


/** WEBPACK FOOTER **
 ** ./components/identity-provider/invalid-idp-session-error.js
 **/